module.exports = __webpack_public_path__ + "static/img/4c1aac7a46cc046c376782383760904.43e097e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4c1aac7a46cc046c376782383760904.png
// module id = 0w0H
// module chunks = 3